import Vue from "vue";
import Router from "vue-router";
import ResetPassword from "@/components/ResetPassword";
import SetPassword from "@/components/SetPassword";
import TaskComplete from "@/components/TaskComplete";
import Login from "@/components/Login";
import Unauthorized from "@/components/unauthorized";
import Home from "@/components/Home";
import admin from "@/components/admin";
import Logout from "@/components/Logout";
import UserAdmin from "@/components/UserAdmin";
import PsClientAdmin from "@/components/PsClientAdmin";

Vue.use(Router);
const router = new Router({
    mode: "history",
    routes: [
        {
            path: "/",
            name: "Login",
            component: Login,
        },
        {
            path: "/resetpassword",
            name: "ResetPassword",
            component: ResetPassword,
        },
        {
            path: "/login",
            name: "Login",
            component: Login,
        },
        {
            path: "/setpassword",
            name: "SetPassword",
            component: SetPassword,
        },
        {
            path: "/taskcomplete",
            name: "TaskComplete",
            component: TaskComplete,
        },
        {
            path: "/unauthorized",
            name: "Unauthorized",
            component: Unauthorized,
        },
        {
            path: "/admin",
            component: admin,
            name: "Admin",
            children: [
                {
                    path: "home",
                    name: "Home",
                    component: Home,
                },
                {
                    path: "logout",
                    name: "Logout",
                    component: Logout,
                },
                {
                    path: "UserAdmin",
                    name: "UserAdmin",
                    component: UserAdmin,
                },
                {
                    path: "PsClientAdmin",
                    name: "PsClientAdmin",
                    component: PsClientAdmin,
                },
            ],
        },
    ],
});

const openRoutes = ["Login", "ResetPassword", "SetPassword", "TaskComplete"];


export default router;
